'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadScript = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LoadScript, _Component);

  // A dictionary mapping script URL to a boolean value indicating if the script
  // has failed to load.


  // A dictionary mapping script URLs to a dictionary mapping
  // component key to component for all components that are waiting
  // for the script to load.
  function LoadScript(props) {
    (0, _classCallCheck3.default)(this, LoadScript);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoadScript.__proto__ || (0, _getPrototypeOf2.default)(LoadScript)).call(this, props));

    _this.constructor.idCount += 1;
    _this.scriptLoaderId = 'id' + _this.constructor.idCount; // eslint-disable-line space-unary-ops
    return _this;
  }

  // A counter used to generate a unique id for each component that uses
  // ScriptLoaderMixin.


  // A dictionary mapping script URL to a boolean value indicating if the script
  // has already been loaded.


  (0, _createClass3.default)(LoadScript, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var url = this.props.url;


      if (this.constructor.loadedScripts[url]) {
        this.runCallback('onLoad');
        return;
      }

      if (this.constructor.erroredScripts[url]) {
        this.runCallback('onError');
        return;
      }

      // If the script is loading, add the component to the script's observers
      // and return. Otherwise, initialize the script's observers with the component
      // and start loading the script.
      if (this.constructor.scriptObservers[url]) {
        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.runCallback.bind(this);
        return;
      }

      this.constructor.scriptObservers[url] = (0, _defineProperty3.default)({}, this.scriptLoaderId, this.runCallback.bind(this));

      this.createScript();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var url = this.props.url;

      var observers = this.constructor.scriptObservers[url];

      // If the component is waiting for the script to load, remove the
      // component from the script's observers before unmounting the component.
      if (observers) {
        delete observers[this.scriptLoaderId];
      }
    }
  }, {
    key: 'createScript',
    value: function createScript() {
      var _this2 = this;

      var _props = this.props,
          url = _props.url,
          onCreate = _props.onCreate,
          onError = _props.onError,
          onLoad = _props.onLoad,
          other = (0, _objectWithoutProperties3.default)(_props, ['url', 'onCreate', 'onError', 'onLoad']); // eslint-disable-line no-unused-vars

      var script = document.createElement('script');

      this.runCallback('onCreate', false);

      script.src = url;
      script.async = 1;

      console.log(other);
      // other.map((propName, propVal) => script[propName] = propVal);

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
        var observers = _this2.constructor.scriptObservers[url];
        (0, _keys2.default)(observers).forEach(function (key) {
          if (shouldRemoveObserver(observers[key])) {
            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
          }
        });
      };
      script.onload = function () {
        _this2.constructor.loadedScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer('onLoad');
          return true;
        });
      };

      script.onerror = function () {
        _this2.constructor.erroredScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer('onError');
          return true;
        });
      };

      document.body.appendChild(script);
    }
  }, {
    key: 'runCallback',
    value: function runCallback(type) {
      var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var callback = this.props[type];

      (0, _invariant2.default)(!required || typeof callback === 'function', 'Callback ' + type + ' must be function, got "' + (typeof callback === 'undefined' ? 'undefined' : (0, _typeof3.default)(callback)) + '" instead');

      return callback && callback();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return LoadScript;
}(_react.Component), _class.propTypes = {
  onCreate: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  url: _propTypes2.default.string.isRequired
}, _class.scriptObservers = {}, _class.loadedScripts = {}, _class.erroredScripts = {}, _class.idCount = 0, _temp);
exports.default = LoadScript;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadScript/LoadScript.js
// module id = 2029
// module chunks = 1